export default __webpack_public_path__ + "static/media/graphsPreview.778a4a4f.png";